import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

export const introductionService = {
  checkIsIntroduced,
  markIntroduced,
};

function checkIsIntroduced(userId, page) {
  return axios
    .get(`${apiEndpoint.introduction}/check-is-introduced`, {
      headers: authHeader(),
      params: {
        user_id: userId,
        page: page,
      },
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === "0000") {
        return res.data;
      }
    });
}

function markIntroduced(userId, page) {
  return axios
    .post(
      `${apiEndpoint.introduction}/mark-introduced`,
      {
        user_id: userId,
        page: page,
      },
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
